/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminUpdateCourseOptions, AdminUpdateCourseResponses } from '../../models/AdminUpdateCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Course
 * {@link /admin/course/:course_id}
 */
export function adminUpdateCourse<ThrowOnError extends boolean = true>(options: Options<AdminUpdateCourseOptions, ThrowOnError>): Promise<UnwrappedResult<AdminUpdateCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PATCH', url: '/admin/course/{course_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminUpdateCourseResponses, ThrowOnError>>
}
